module.exports = __webpack_public_path__ + "6943db530698412e9a40b9e9e7c57d12.png";